import { createAction } from "@reduxjs/toolkit";
import { FETCH_EXTERNAL_MEDIA_LIBRARY, FETCH_MEDIA_LIBRARY, FETCH_MEDIA_LIBRARY_CATEGORIES, FETCHING_EXTERNAL_MEDIA_LIBRARY_FAILED, FETCHING_EXTERNAL_MEDIA_LIBRARY_SUCCEEDED, FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED, FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED, FETCHING_MEDIA_LIBRARY_FAILED, FETCHING_MEDIA_LIBRARY_SUCCEEDED } from "./actionTypes";
import buildUrl from "build-url-ts";
import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import { FetchExternalMediaLibraryErrorResponse, FetchExternalMediaLibraryRequest, FetchExternalMediaLibraryResponse, FetchMediaLibraryCategoriesErrorResponse, FetchMediaLibraryCategoriesRequest, FetchMediaLibraryCategoriesResponse, FetchMediaLibraryErrorResponse, FetchMediaLibraryRequest, FetchMediaLibraryResponse } from "../../types/mediaLibrary";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;

export const fetchMediaLibrary = createAction<FetchMediaLibraryRequest>(FETCH_MEDIA_LIBRARY);
export const fetchingMediaLibrarySucceeded = createAction<FetchMediaLibraryResponse>(FETCHING_MEDIA_LIBRARY_SUCCEEDED);
export const fetchingMediaLibraryFailed = createAction<FetchMediaLibraryErrorResponse>(FETCHING_MEDIA_LIBRARY_FAILED);

const fetchMediaLibrarySaga = function* (action: ReturnType<typeof fetchMediaLibrary>): any {
  const { entityType, mediaType, category, page, limit, query, sort, order } = action.payload as FetchMediaLibraryRequest;

  let url = buildUrl(apiUrl, {
    path: "/api/2.0/image_library",
  });

  let data: any = {
    entityType: entityType,
    mediaType: mediaType,
    page: page,
    limit: limit,
  }

  if(category) {
    url = buildUrl(apiUrl, {
      path: "api/2.0/image_library/categories",
      queryParams: {
        type: entityType,
      }
    });

    data = {
      categoryId: category,
      mediaType: mediaType,
      page: page,
      limit: limit,
    }
  }

  if (query) data.query = query;
  if (sort) data.sort = sort;
  if (order) data.order = order;

  const fetchMediaLibraryApi = () => {
    return axios.post(url, data).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMediaLibraryApi);
    yield put(fetchingMediaLibrarySucceeded({
      entityType: entityType,
      mediaType: mediaType,
      category: category,
      query: query,
      sort: sort,
      order: order,
      response: response,
    }));
  } catch (error) {
    console.log(error);
    yield put(fetchingMediaLibraryFailed({
      entityType: entityType,
      mediaType: mediaType,
      category: category,
      query: query,
      sort: sort,
      order: order,
      error: error,
    }));
  }
};

//Fetch Categories for entityType
export const fetchMediaLibraryCategories = createAction<FetchMediaLibraryCategoriesRequest>(FETCH_MEDIA_LIBRARY_CATEGORIES);
export const fetchingMediaLibraryCategoriesSucceeded = createAction<FetchMediaLibraryCategoriesResponse>(FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED);
export const fetchingMediaLibraryCategoriesFailed = createAction<FetchMediaLibraryCategoriesErrorResponse>(FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED);

const fetchMediaLibraryCategoriesSaga = function* (action: ReturnType<typeof fetchMediaLibraryCategories>): any {
  const { entityType } = action.payload as FetchMediaLibraryCategoriesRequest;

  const url = buildUrl(apiUrl, {
    path: "/api/2.0/media_library_category/categories",
    queryParams: {
      type: entityType,
    }
  });

  const fetchMediaLibraryCategoriesApi = () => {
    return axios.get(url).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMediaLibraryCategoriesApi);
    yield put(fetchingMediaLibraryCategoriesSucceeded({
      entityType: entityType,
      response: response,
    }));
  } catch (error) {
    yield put(fetchingMediaLibraryCategoriesFailed({
      entityType: entityType,
      error: error,
    }));
  }
};

//Fetch Media library for pexel
export const fetchExternalMediaLibrary = createAction<FetchExternalMediaLibraryRequest>(FETCH_EXTERNAL_MEDIA_LIBRARY);
export const fetchingExternalMediaLibrarySucceeded = createAction<FetchExternalMediaLibraryResponse>(FETCHING_EXTERNAL_MEDIA_LIBRARY_SUCCEEDED);
export const fetchingExternalMediaLibraryFailed = createAction<FetchExternalMediaLibraryErrorResponse>(FETCHING_EXTERNAL_MEDIA_LIBRARY_FAILED);

const fetchExternalMediaLibrarySaga = function* (action: ReturnType<typeof fetchExternalMediaLibrary>): any {
  const { mediaType, mediaLibraryType, query, orientation, hexcode, page } = action.payload as FetchExternalMediaLibraryRequest;

  const url = buildUrl(apiUrl, {
    path: "api/2.0/external_library",
    queryParams: {
      type: mediaType,
      mediaLibraryType: mediaLibraryType,
      query: query,
      orientation: orientation,
      hexcode: hexcode,
      page: page,
    }
  });

  const fetchMediaLibraryCategoriesApi = () => {
    return axios.get(url).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMediaLibraryCategoriesApi);
    yield put(fetchingExternalMediaLibrarySucceeded({
      mediaType: mediaType,
      mediaLibraryType: mediaLibraryType,
      query: query,
      response: response,
    }));
  } catch (error) {
    yield put(fetchingExternalMediaLibraryFailed({
      mediaType: mediaType,
      mediaLibraryType: mediaLibraryType,
      query: query,
      error: error,
    }));
  }
};

export default function* mediaLibrarySaga() {
  yield takeEvery(FETCH_MEDIA_LIBRARY, fetchMediaLibrarySaga);
  yield takeEvery(FETCH_MEDIA_LIBRARY_CATEGORIES, fetchMediaLibraryCategoriesSaga);
  yield takeEvery(FETCH_EXTERNAL_MEDIA_LIBRARY, fetchExternalMediaLibrarySaga);
};